/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
import { get } from "@/utils";
import Axios, { AxiosResponse, AxiosStatic } from "axios";

export const STAGING_API = "https://sismobile.htu.edu.jo/";
export const PRODUCTION_API = "https://htu.edu.jo/";

Axios.defaults.baseURL = STAGING_API;

declare module "axios" {
  interface AxiosStatic {
    setUrl: () => Promise<void>;
  }
}

export async function getBaseUrl() {
  const baseURL = STAGING_API;
  return baseURL;
}

const onSuccess = function (response: AxiosResponse) {
  // console.warn("Request Successful!", response);
  return response.data;
};

const onError = async function async(error: any) {
  console.error("FAILED Response!:", get(error, "response"));
  console.error("FAILED Status:", get(error, "response.status"));
  console.error("FAILED Data:", get(error, "response.data"));
  console.error("FAILED Headers:", get(error, "response.headers"));
  if (Axios.isCancel(error)) {
    return Promise.reject(error);
  }

  // const errorStatus = get(error, 'response.status', 0);

  return Promise.reject(error);
};
Axios.interceptors.request.use((config) => {
  // console.log(config);
  return config;
});

Axios.interceptors.response.use(onSuccess, onError);

// Axios["setUrl"] = async function () {
//   const url = await getBaseUrl();
//   this.defaults.baseURL = url;
// };

const request = Axios as AxiosStatic & {
  setUrl: any;
};

export default request;
